// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectionDetailActions_container__174QY"};